/**
 * Playback ID Mux canónico para el funnel de membresía / Dual CTA.
 * Override por admin (premium-invite, country-template, dual-cta-home) tiene prioridad.
 */

export const CANONICAL_MUX_PLAYBACK_ID =
  "pu5HknWerpfw016KwhWZRmCKOZAkcsHeygRoiOFN9iAI";

const PLAYBACK_ID_RE = /^[a-zA-Z0-9][a-zA-Z0-9_-]{3,79}$/;

export function isValidMuxPlaybackId(raw: string | undefined | null): boolean {
  const t = (raw || "").trim();
  return PLAYBACK_ID_RE.test(t);
}

/** Devuelve el candidato si es válido; si no, el ID canónico de prod. */
export function coalesceMuxPlaybackId(
  candidate: string | undefined | null,
): string {
  const t = (candidate || "").trim();
  if (isValidMuxPlaybackId(t)) return t;
  return CANONICAL_MUX_PLAYBACK_ID;
}